import {createRef, RefObject, useState} from 'react';
import {SActionBtn, SLowcodeList, STableActions} from 'shj-components';
import {message, Select, Switch} from 'antd';
import {RechargeModel} from './addAndEdit/recharge';
import {AddAndEditModel} from './addAndEdit';
import {getAccountsPageByRequest, UpdateInsuranceStatus} from '@/services/insureManagement'
import CheckThePhone from "@/components/CheckThePhone";
import UrlConfig from '@/api/UrlConfigs'
import { getWorkTypeList } from '@/services';
import { RenewalModel } from './renewal';
import { moneyRender } from '@/utils';
import { getEnums } from '@/services/homeService';
import Record from './record';

const InsureAccountList = (props: any) => {
    const { Option } = Select;
    const listRef: RefObject<any> = createRef();
    const [visibleDrawer, setVisibleDrawer] = useState(false);
    const [accountId, setAccountId] = useState('');
    const config = {
        rowSelection: false,
        searchFormConfig: false,
        columns: [
            {
                title: "门店",
                dataIndex: "companyName",
                width: 200
            },
            {
                title: "姓名",
                dataIndex: "employeeName",
                width: 100,
                ellipsis: true,
            },
            {
                title: "技能标签",
                dataIndex: "workTypeNames",
                width: 180,
                ellipsis: true,
            },
            {
                title: "身份证",
                dataIndex: "idCard",
                width: 200,
                // render: "checkPhone"
            },
            {
                title: "账户总缴纳(¥)",
                dataIndex: "totalAmount",
                width: 180,
                render: "money"
            },
            {
                title: "账户余额(¥)",
                dataIndex: "balance",
                width: 160,
                render: "money"
            },
            {
                title: "状态",
                dataIndex: "statuName",
                width: 100
            },
            {
                title: "入职日期",
                dataIndex: "joinDate",
                itemType: "date",
                width: 180
            },
            {
                title: "总参保月数",
                dataIndex: "totalMonths",
                width: 150
            },
            {
                title: "保险开始",
                dataIndex: "startTime",
                itemType: "date",
                width: 180
            },
            {
                title: "保险结束",
                dataIndex: "endTime",
                itemType: "date",
                width: 180
            },
            {
                title: "续保状态",
                dataIndex: "renewalStatus",
                width: 140,
                render: "insuranceStatuFn"
            },
            {
                title: "操作",
                dataIndex: "operation",
                width: 250,
                fixed: "right",
                render: "operationFn"
            }
        ],
        search: [
            {
                name: "statuss",
                label: "状态",
                itemType: "select",
                key: "key",
                labelKey: "description",
                showSearch: true,
                optionFilterProp: "children",
                allowClear: true,
                mode: "multiple",
                data: "insuranceStatuCodeList"
            },
            {
                name: "workTypeIds",
                label: "技能标签",
                itemType: "select",
                key: "id",
                labelKey: "name",
                showSearch: true,
                optionFilterProp: "children",
                allowClear: true,
                mode: "multiple",
                data: "workTypeList"
            },
            {
                name: "searchName",
                label: "姓名/身份证"
            },
            {
                name: "companyIds",
                label: "门店",
                itemType: "custom",
                render: "setCompany"
            }
        ],
        footer: [
            {
                label: "增加账户",
                type: "primary",
                auth: "createAccountBtnAuth",
                events: ["onClick:onAdd"]
            },
        ]
    }
    const fetchList = (values) => {
        return new Promise(async (resolve, reject) => {
            try {
              const { current, pageSize, query } = values;
              getAccountsPageByRequest(current, pageSize, query).then(data => resolve(data))
            } catch (e) {
              reject({ success: false });
            }
          });
    };
    const getInsuranceStatu = () => {
        return getEnums("plus-pm", "com.shj.saas.plus.pm.domain.insur.enums.InsurStatusEnum").then((response: any) => {
            return response;
          });
    };
    const onChangeInsuranceStatu = (record) => {
        let data = {
            renewalStatus: !record.renewalStatus,
            id: record.id
        }
        UpdateInsuranceStatus(data).then((response: any) => {
            message.success(response?.message)
            listRef.current?.reload();
        })
    }
    const onAdd = ()=>{
        AddAndEditModel({
            fn: () => {
                listRef.current?.reload();
            },
        });
    }
    const onRecharge = (record) => {
        RechargeModel({
            fn: () => {
                listRef.current?.reload();
            },
            ...record,
        });
    }
    const onRenewal = (record) => {
        RenewalModel({
            fn: () => {
                listRef.current?.reload();
            },
            ...record,
        })
    }
    const showRecord = (record) => {
        setVisibleDrawer(true)
        setAccountId(record.id)
    }
    const closeDetails = () => {
        setVisibleDrawer(false)
      }
    const getStatusOptions = () => {
        return new Promise(async (resolve) => {
            try {
                const insuranceStatuCodeList = await getInsuranceStatu();
                const workTypeList = await getWorkTypeList();
                resolve({
                    workTypeList,
                    insuranceStatuCodeList,
                });
            } catch (e) { }
        });
    };
    const extension = {
        request: { fetchList, getStatusOptions },
        events: {
            onAdd
        },
        customRender: {
            checkPhone(text: any, re: any) {
                return <CheckThePhone initValue={text} url={`${UrlConfig.plusPmWeb.NewInsurAccountsId}/${re?.id}`}
                auth="insureInfoIdCard"
                showValue={'idCard'}
                type="GET"/>
            },
            money(text: any) {
                return <span>{moneyRender(text)}</span>
            },
            insuranceStatuFn(text: any, record: any) {
                return (<Switch value={text} checkedChildren="续保" unCheckedChildren="停保" onChange={() => onChangeInsuranceStatu(record)} />)
            },
            operationFn(_text: any, record: any) {
                return (
                    <STableActions>
                        <SActionBtn onClick={() => onRecharge(record)} auth="insureInfoRecharge">
                            手动充值
                        </SActionBtn>
                        <SActionBtn  onClick={() => showRecord(record)} auth="insureInfoRecord">
                            流水
                        </SActionBtn>
                        <SActionBtn  onClick={() => onRenewal(record)} auth="insureInfoContinue">
                            手动续保
                        </SActionBtn>
                    </STableActions>
                );
            },
            setCompany({name, form }: any) {
                return (
                    <Select
                        mode="multiple"
                        showSearch
                        allowClear={true}
                        filterOption={(input: any, option: any) => {
                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }}
                        onChange={(value) => {
                            form.setFieldsValue({
                                [name]: value,
                            });
                        }}
                    >
                        {(props.allCompanyList || []).map((item: any, i: any) => {
                            return (
                                <Option key={i} value={item.id}>
                                    {item.companyName}
                                </Option>
                            );
                        })}
                    </Select>
                );
            },
        },
    };
    return (
        <div>
            <SLowcodeList
                ref={listRef}
                config={config}
                searchMode="group"
                {...extension}
            />
            <Record  visibleDrawer={visibleDrawer} accountId={accountId} closeDetails={closeDetails}></Record>
        </div>
    );
};
export default InsureAccountList
